import Form from "react-bootstrap/Form";

import React, { useEffect, useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import {
  formatDate,
  decreaseDateByOneDay,
  getValue,
} from "modules/utilities/utility";
import CardDiv from "modules/common/card-div/CardDiv";
import AppointmentTable from "modules/all_doctor_dashboard/AppointmentTable";
import useDoctorDashboardStore from "modules/all_doctor_dashboard/store";
import moment from "moment";
import { revenueRepEndDate, revenueRepStartDate } from "functionCall";
import { isEmpty } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useDoctorSlot } from "modules/dashboards/actionables/store";

function MyAppointment() {
  const { setMarkSlot } = useDoctorSlot();
  const { appointmentData, appointmentLoading, fetchAppointmentData } =
    useDoctorDashboardStore();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [newDate, setNewDate] = useState(new Date());
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const filterStartDate = searchParams.get("startDate");
  const filterEndDate = searchParams.get("endDate");

  useEffect(() => {
    setMarkSlot(false);
  }, []);
  useEffect(() => {
    fetchAppointmentData(filterStartDate, filterEndDate);
  }, [filterStartDate, filterEndDate]);

  const tableData = useMemo(() => {
    if (isEmpty(appointmentData)) return [];

    return appointmentData.map((appointment) => ({
      key: getValue(appointment, "_id"),
      case_id: getValue(appointment, "case_id"),
      name: getValue(appointment, "user.first_name"),

      status: getValue(appointment, "case.status"),
      tag: "slot_booking",
      slot_time: getValue(appointment, "reminder_date"),
      booking_time: getValue(appointment, "createdAt"),
      payment_status: getValue(appointment, "payment_status"),
      unanswered_count: getValue(appointment, 'unanswered_count') || 0,
    }));
  }, [appointmentData]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate("");
  };
  const handleResetEndDate = () => {
    setEndDate("");
  };

  const handleFilterSubmit = (event) => {
    event.preventDefault();
    if (startDate && endDate) {
      navigate(
        `/my-appointments?startDate=${revenueRepStartDate(
          formatDate(startDate)
        )}&endDate=${revenueRepEndDate(formatDate(endDate))}`
      );
    } else {
      navigate(
        `/my-appointments?startDate=${moment()
          .startOf("day")
          .toISOString()}&endDate=${moment().endOf("day").toISOString()}`
      );
    }
  };
  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <div className="fs-2">My Appointment</div>
          <div>
            <Form
              onSubmit={handleFilterSubmit}
              className=" d-flex gap-2 align-self-end flex-wrap"
            >
              <div className="d-flex gap-2">
                <Form.Group>
                  <div className="input-container-summary">
                    {startDate ? (
                      ""
                    ) : (
                      <div className="calendar-icon-container-summary">
                        <FontAwesomeIcon
                          icon={faCalendarAlt}
                          className="calendar-icon"
                        />
                      </div>
                    )}
                    <DatePicker
                      selected={newDate}
                      onChange={handleStartDateChange}
                      placeholderText="Start Date"
                      dateFormat="dd-MM-yyyy"
                      value={startDate ? formatDate(startDate) : ""}
                      className="input-with-icon"
                    />
                    {startDate && (
                      <span
                        className="reset-icon"
                        onClick={handleResetStartDate}
                      >
                        <BsX />
                      </span>
                    )}
                  </div>
                </Form.Group>
                <Form.Group>
                  <div className="input-container-summary">
                    {endDate ? (
                      ""
                    ) : (
                      <div className="calendar-icon-container-summary">
                        <FontAwesomeIcon
                          icon={faCalendarAlt}
                          className="calendar-icon"
                        />
                      </div>
                    )}
                    <DatePicker
                      selected={newDate}
                      onChange={handleEndDateChange}
                      placeholderText="End Date"
                      dateFormat="dd-MM-yyyy"
                      value={endDate ? formatDate(endDate) : ""}
                    />
                    {endDate && (
                      <span className="reset-icon" onClick={handleResetEndDate}>
                        <BsX />
                      </span>
                    )}
                  </div>
                </Form.Group>
                <Button variant="primary" className="mt-1 w-100" type="submit">
                  Submit
                </Button>
              </div>
            </Form>
          </div>
        </div>
      }
      component={
        <div>
          <AppointmentTable
            isLoading={appointmentLoading}
            tableData={tableData}
          />
        </div>
      }
    />
  );
}

export default MyAppointment;
